import { render, staticRenderFns } from "./FullscreenButton.vue?vue&type=template&id=f274c0e0"
import script from "./FullscreenButton.vue?vue&type=script&lang=js"
export * from "./FullscreenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports